import { Drawer, DrawerContent } from '@/components/ui/drawer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons';
import { ReactNode, Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

interface CreateTermineDrawerWrapperProps {
  onClose: () => void;
  children: ReactNode;
}

export function CreateTermineDrawerWrapper({
  onClose,
  children,
}: CreateTermineDrawerWrapperProps) {
  const { t } = useTranslation();

  return (
    <Drawer
      repositionInputs={false}
      open
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
      dismissible>
      <DrawerContent
        className={cn(
          'h-svh w-screen',
          'rounded-none border-0',
          'data-[vaul-drawer-direction=bottom]:mt-0',
          'data-[vaul-drawer-direction=bottom]:max-h-none',
          'data-[vaul-drawer-direction=bottom]:rounded-none',
          'data-[vaul-drawer-direction=bottom]:border-0',
        )}>
        <Suspense
          fallback={
            <div className="flex flex-col gap-4 items-center justify-center text-sm">
              <FontAwesomeIcon
                icon={faSpinnerThird}
                className="text-primary-blue-B200"
                spin
                size="4x"
              />
              {t('actions.loading')}
            </div>
          }>
          {children}
        </Suspense>
      </DrawerContent>
    </Drawer>
  );
}
